var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortedReverseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5650",
    "data-name": "Group 5650",
    transform: "translate(-14181 78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4640",
    "data-name": "Path 4640",
    d: "M183.918,218.069l.023-.03c.009-.012.018-.024.026-.036s.015-.024.022-.037.014-.022.02-.034.012-.025.018-.038.012-.024.017-.036.009-.025.014-.038.01-.026.014-.04.007-.025.01-.038.007-.027.01-.042,0-.03.007-.044,0-.024.005-.037a.843.843,0,0,0,0-.166c0-.012,0-.024-.005-.037s0-.03-.007-.044-.007-.028-.01-.042-.006-.026-.01-.038-.009-.027-.014-.04-.009-.025-.014-.038-.011-.024-.017-.036-.012-.026-.018-.038-.013-.023-.02-.034-.014-.025-.022-.037-.018-.024-.026-.036l-.023-.03c-.017-.021-.036-.041-.055-.061h0l-3.36-3.36a.84.84,0,1,0-1.188,1.188l1.926,1.926h-9.733a.84.84,0,0,0,0,1.68h9.733l-1.926,1.926a.84.84,0,1,0,1.188,1.188l3.36-3.36h0Q183.892,218.1,183.918,218.069Z",
    transform: "translate(13972.663 108.108) rotate(-90)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15094",
    "data-name": "Rectangle 15094",
    width: 18,
    height: 18,
    transform: "translate(14181 -78)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortedReverseIcon);
export default __webpack_public_path__ + "static/media/sorted-reverse-icon.d8dcaa74285c0b9d98c369c0f8c0014a.svg";
export { ForwardRef as ReactComponent };